<template>
  <div class="row mt-4">
    <div class="col-sm">
    </div>
    <div class="col-sm">
      <iframe width="400" height="400" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1499270632%3Fsecret_token%3Ds-BLSVhrzkKue&color=%235c8a80&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"></iframe><div style="font-size: 10px; color: #cccccc;line-break: anywhere;word-break: normal;overflow: hidden;white-space: nowrap;text-overflow: ellipsis; font-family: Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif;font-weight: 100;"></div>
      <a href="https://www.dropbox.com/s/4sdiw3vhx17z6dn/Paul%20%26%20Marieke%20-%20Festival%20Megamix.mp3?dl=0">Download</a>
    </div>
    <div class="col-sm">
    </div>

  </div>
</template>

<script>
export default {
  name: 'PaulMariekeFestivalMegamix.vue',
};
</script>

<style scoped>

</style>